export function clearSessionStorage(key) {
  sessionStorage.removeItem(key);
}

export function getSessionStorage(key) {
  return sessionStorage.getItem(key);
}

export function setSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    console.log('session storage is not supported by browser');
  }
}



// WEBPACK FOOTER //
// ./src/Utils/SessionStorage.js